// extracted by mini-css-extract-plugin
export default {"font-renta":"GlobalNotificationSettingsPage_font-renta__3M2Wd"};